export default __webpack_public_path__ + "static/media/file.8ea3c7d6.svg";